import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b7857d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-flex tw-flex-row tw-items-center" }
const _hoisted_2 = { class: "tw-flex tw-justify-around tw-items-center tw-w-full" }
const _hoisted_3 = { class: "tw-flex tw-flex-row tw-items-center tw-flex-1" }
const _hoisted_4 = { class: "tw-flex tw-flex-row tw-items-center" }
const _hoisted_5 = {
  class: /*#__PURE__*/_normalizeClass(['tw-text-[#B7B7B7] tw-text-[11px] tw-p-[6px] tw-pl-[9px]'])
}
const _hoisted_6 = {
  class: /*#__PURE__*/_normalizeClass([
              'tw-inline-flex tw-gap-[5px] tw-items-center tw-px-[5px] tw-py-[3px] tw-text-[11px] tw-text-[#387DFF] tw-bg-[#F2F8FF] tw-font-medium tw-rounded-[6px]',
            ])
}
const _hoisted_7 = { class: "tw-m-0" }
const _hoisted_8 = ["placeholder", "onKeyup"]
const _hoisted_9 = {
  key: 0,
  class: "hover-modal"
}

import SearchIcon from "@/components/svgs/searchIcon.vue";
import CloseBoxIcon from "@/components/svgs/closeBoxIcon.vue";
import { getComponentUiText } from "@/utils/utilities";
import BaseForm from "../common/form/baseForm.vue";
import { onUnmounted, ref, watch } from "vue";
import ModalHoverSearchAssessment from "./modalHoverSearchAssessment.vue";
import store from "@/store";
import { SEARCH_TYPE_ID } from "@/utils/constants";
import debounce from "lodash.debounce";


export default /*#__PURE__*/_defineComponent({
  __name: 'searchFilter',
  props: {
  hintText: {
    type: String,
    required: true,
  },
  modelValue: {
    type: String,
    required: true,
  },
  isShowFilterAction: {
    type: Boolean,
    default: false,
  },
  selectedCategory: {
    type: Object,
    default: () => {},
  },
},
  emits: ["update:modelValue", "update:searchFocus"],
  setup(__props, { emit }) {

const props = __props;


const searchInputModal = ref<HTMLInputElement | null>(null);



const valueSearch = ref(props.modelValue);
const lastCallApiValueSearch = ref("");
const isInputFocused = ref(false);
let valueCheckSearch = "";

watch(
  () => props.modelValue,
  debounce((newValue) => {
    valueSearch.value = newValue;
  }, 800),
  { immediate: true },
);

watch(
  () => props.isShowFilterAction,
  (newValue) => {
    if (newValue) {
      isInputFocused.value = false;
    }
  },
);

const onEnter = () => {
  isInputFocused.value = false;

  if (valueSearch.value && valueSearch.value !== lastCallApiValueSearch.value) {
    postAndGetRecentSearch();
  }
};

// const updateInput = (e: any) => {
//   emit("update:modelValue", e.target.value);
// };

const debouncedSearch = debounce(() => {
  emit("update:modelValue", valueSearch.value);
}, 800);

const isClearClicked = ref(false);

const clearData = debounce(() => {
  isClearClicked.value = true;
  valueSearch.value = "";
  emit("update:modelValue", "");
}, 500);

const updateCurrentValueSearch = (value: string) => {
  valueSearch.value = value;
  emit("update:modelValue", value);
};

const onInputFocus = (isFocus) => {
  emit("update:searchFocus", isFocus);
  valueCheckSearch = valueSearch.value;
  isInputFocused.value = isFocus;
};

const onBlur = () => {
  setTimeout(() => {
    if (valueSearch.value !== "") {
      isInputFocused.value = false;
    } else {
      if (isClearClicked.value) {
        isClearClicked.value = false;
        searchInputModal.value?.focus();
      } else {
        isInputFocused.value = false;
      }
    }
  }, 711);
  if (valueSearch.value && valueSearch.value !== lastCallApiValueSearch.value) {
    emit("update:searchFocus", false);
    postAndGetRecentSearch();
  }
};

const postAndGetRecentSearch = async () => {
  lastCallApiValueSearch.value = valueSearch.value;
  if (valueSearch.value === "" || valueCheckSearch === valueSearch.value)
    return;

  await store.dispatch("Assessment/postRecentSearchInput", {
    searchTypeId: SEARCH_TYPE_ID.CL_INPUT,
    searchData: {
      text: valueSearch.value,
    },
  });
  await store.dispatch("Assessment/getRecentSearches", {
    searchTypeId: SEARCH_TYPE_ID.CL_INPUT,
  });
};

onUnmounted(() => {
  window.removeEventListener("click", () => {});
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseForm, {
    id: "click-filter",
    class: "search-box-assessment tw-flex tw-items-center tw-rounded-[6px] tw-border tw-border-solid tw-border-[#EFF0F1] tw-bg-[#ffffff] tw-pl-[15px] tw-pt-[6px] tw-pb-[6px] tw-pr-[6px]"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(SearchIcon, {
          size: 15,
          color: "#B7B7B7"
        })
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "icon"),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("span", null, _toDisplayString(_unref(getComponentUiText)(
                "app-component-assessments-search-box-assessment-tag-2",
              )), 1)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("p", _hoisted_7, _toDisplayString(__props.selectedCategory && __props.selectedCategory.text
                  ? __props.selectedCategory.text
                  : _unref(getComponentUiText)(
                      "app-component-assessments-assessment-search-modal-tag-1",
                    )), 1)
            ])
          ]),
          _withDirectives(_createElementVNode("input", {
            id: "search-input-modal",
            ref_key: "searchInputModal",
            ref: searchInputModal,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((valueSearch).value = $event)),
            type: "text",
            placeholder: __props.hintText,
            class: "input-assessment tw-relative",
            onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(debouncedSearch) && _unref(debouncedSearch)(...args))),
            onFocus: _cache[2] || (_cache[2] = ($event: any) => (onInputFocus(true))),
            onBlur: onBlur,
            onKeyup: _withKeys(onEnter, ["enter"])
          }, null, 40, _hoisted_8), [
            [_vModelText, valueSearch.value]
          ]),
          (isInputFocused.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createVNode(ModalHoverSearchAssessment, {
                  "is-search-modal-assessment": false,
                  onCloseModal: _cache[3] || (_cache[3] = ($event: any) => (onInputFocus(false))),
                  onUpdateCurrentValueSearch: updateCurrentValueSearch
                })
              ]))
            : _createCommentVNode("", true)
        ]),
        (__props.modelValue !== '')
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              id: "close-iten-modal",
              type: "button",
              class: "tw-bg-transparent tw-border-none tw-outline-none tw-cursor-pointer tw-ml-[19px]",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_unref(clearData) && _unref(clearData)(...args)))
            }, [
              _createVNode(CloseBoxIcon, {
                size: 15,
                color: "#DBDBDB"
              })
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 3
  }))
}
}

})